/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Score_ForbiddenInputs */



/**
* | output |
* | --- |
* | "Not authorized to score this table" |
*
* @param {Err_Tournament_Score_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_score_forbidden = /** @type {((inputs?: Err_Tournament_Score_ForbiddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Score_ForbiddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non autorisé à scorer cette table")
	if (locale === "es") return /** @type {LocalizedString} */ ("No autorizado para puntuar esta mesa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não autorizado a pontuar esta mesa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non autorizzato a segnare il punteggio di questo tavolo")
	return /** @type {LocalizedString} */ ("Not authorized to score this table")
});